import { render, staticRenderFns } from "./CalendarioLegal.vue?vue&type=template&id=34b4955c"
import script from "./CalendarioLegal.vue?vue&type=script&lang=js"
export * from "./CalendarioLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports